import ConfirmTable from "../../components/react-table/solicitude-maintenance";

function ConfirmsSolicitudesCompra() {
  return (
    <div>
      <ConfirmTable contextmenu="confirma" />
    </div>
  );
}

export default ConfirmsSolicitudesCompra;
